import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { setProfileModalPage } from '../../../modules/profile/actions/creators'

import PointsMechanics from '../components/PointsMechanics/PointsMechanics'

const mapStateToProps = reduxState => {
  const { auth, profile } = reduxState

  const { accessToken } = auth

  const { profileModalPage } = profile

  return {
    accessToken,
    profileModalPage,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setProfileModalPage,
    },
    dispatch,
  )

const ConnectedManageCardsPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PointsMechanics)

export default ConnectedManageCardsPage
